// Mock data for Ecological Energy Landing Page

export const mockData = {
  company: {
    name: "Ecological Energy",
    tagline: "Transforming Commercial Energy Landscapes",
    description: "Leading B2B renewable energy development consultancy specialising in onshore wind turbines, commercial solar projects, and energy storage solutions.",
    logo: "https://customer-assets.emergentagent.com/job_clean-energy/artifacts/byvjd4jp_Ecologicalv6-final-registered.jpg",
    heroGraphic: "https://customer-assets.emergentagent.com/job_clean-energy/artifacts/sus8gu0e_New_Ecological_v8.png"
  },

  achievements: {
    windProjects: "40+",
    solarProjects: "50+",
    yearsExperience: "15+",
    megawattsDeployed: "500+"
  },

  services: [
    {
      id: 1,
      title: "Planning & Permissions",
      description: "Navigate permission processes and secure energy-related grants with our extensive planning and regulatory expertise.",
      icon: "FileCheck"
    },
    {
      id: 2,
      title: "Grid Connection & Export",
      description: "Optimise power import/export through strategic connections with National Grid and district network operators.",
      icon: "Zap"
    },
    {
      id: 3,
      title: "Buying & Selling Power",
      description: "Maximize carbon credentials and financial outcomes through strategic power purchase agreements and energy trading.",
      icon: "TrendingUp"
    },
    {
      id: 4,
      title: "Financing & Investment",
      description: "Secure project funding through our network of finance partners, from private financing to fully grant-funded projects.",
      icon: "PiggyBank"
    },
    {
      id: 5,
      title: "Research & Development",
      description: "Leading R&D in renewable energy and storage solutions to guide future-proof investment decisions.",
      icon: "Lightbulb"
    },
    {
      id: 6,
      title: "Project Integration",
      description: "Strategic consulting to manage, generate, store, and trade energy for combined marginal gains.",
      icon: "Settings"
    },
    {
      id: 7,
      title: "Generating Electricity",
      description: "End-to-end services for onshore wind and commercial solar PV systems, from assessment to management.",
      icon: "Sun"
    },
    {
      id: 8,
      title: "Storing Energy",
      description: "Deploy advanced energy storage solutions to enhance security and optimise profitability.",
      icon: "Battery"
    },
    {
      id: 9,
      title: "Monitoring & Controlling",
      description: "Implement energy monitoring systems to reduce costs and maximize advantages across all organisation sizes.",
      icon: "BarChart3"
    }
  ],

  specialties: [
    {
      title: "Onshore Wind Development",
      description: "Comprehensive wind turbine project development from site assessment to operational management."
    },
    {
      title: "Commercial Solar Solutions", 
      description: "Industrial-scale solar PV systems designed for maximum efficiency and return on investment."
    },
    {
      title: "Energy Storage Systems",
      description: "Advanced battery storage integration for enhanced energy security and grid stability."
    },
    {
      title: "Community Energy Projects",
      description: "Specialist development of community-owned and community-led renewable energy initiatives."
    }
  ],

  contact: {
    phone: "+44 (0) 1234 567890",
    email: "info@ecological.energy",
    address: "Renewable Energy House, Green Technology Park, UK"
  },

  consultationForm: {
    fields: [
      { name: "companyName", label: "Company Name", type: "text", required: true },
      { name: "contactName", label: "Contact Name", type: "text", required: true },
      { name: "email", label: "Email Address", type: "email", required: true },
      { name: "phone", label: "Phone Number", type: "tel", required: true },
      { name: "projectType", label: "Project Interest", type: "select", required: true, options: [
        "Onshore Wind Development",
        "Commercial Solar Installation", 
        "Energy Storage Solutions",
        "Community Energy Project",
        "Grid Connection Services",
        "Energy Trading & Finance",
        "Other/Multiple Services"
      ]},
      { name: "projectScale", label: "Project Scale", type: "select", required: true, options: [
        "Under 1MW",
        "1-5MW", 
        "5-20MW",
        "20MW+",
        "Portfolio of Projects"
      ]},
      { name: "timeline", label: "Project Timeline", type: "select", required: true, options: [
        "Immediate (0-3 months)",
        "Short term (3-12 months)",
        "Medium term (1-2 years)", 
        "Long term (2+ years)",
        "Exploring options"
      ]},
      { name: "message", label: "Project Details", type: "textarea", required: false }
    ]
  }
};